import { useEffect } from 'react';
import { Project } from '../models/project';
import { useProjectUsersStore } from '../stores/projectUsersStore';

export function useProjectUsers(projectId: Project['id']) {
  const fetch = useProjectUsersStore((state) => state.fetch);
  const snapshot = useProjectUsersStore((state) => state.getSnapshot(projectId));

  useEffect(() => {
    fetch(projectId);
  }, [fetch, projectId]);

  return snapshot;
}
